export default __webpack_public_path__ + "static/media/UsersActive.96a80800.svg";